// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceLimitMeasure } from './PriceLimitMeasure';
import { TradingMode } from './TradingMode';
export class InstrDateSettings {
    constructor() {
        this.DeliveryStatus = 0;
        // синтетически сгенерированная дата.
        // Обычно равна MaturityDate. Для фьючей с показом дня
        // считается по формуле (день_экспирации + месяц_матурити + год_матурити)
        // по ней осуществляется построение тикера, подписка, торговля, запрос истории...
        this.ContractMonthDate = null;
        // Дата экспирации фьюча (новое поле, для старых серверов=ContractMonthDate)
        this.ExpirationDate = null;
        // Видимая дата фьюча (новое поле, для старых серверов=ContractMonthDate)
        this.MaturityDate = null;
        this.LastTradeDate = null;
        this.SettlementDate = null;
        this.NoticeDate = null;
        this.FirstTradeDate = null;
        this.AutoCloseDate = null;
        this.IsContinuous = false;
        this.ShowDayForFutures = false;
        this.LowLimit = NaN;
        this.HightLimit = NaN;
        this.PriceLimitMeasure = PriceLimitMeasure.DISABLE;
        this.TradingMode = TradingMode.FullyClosed;
        // дата контракта у фьючерсного андерлаера
        this.UnderlierDate = null;
        // отстутствует - выкл.; присутствует, от 0 до ?
        // в процентах (т.е. значение 100 - это 100%)
        this.CheckIntrinsic = null;
        this.StrikePricesList = [];
        // For NonFixed list
        this.ContractID = 0;
        this.minLot = null;
        this.maxLot = null;
        this.maxLotInCash = null;
        this.LotSize = null;
        this.PointSize = null;
        this.LotStep = null;
        this.FuturesTickCoast = null;
        this.VariableTicks = null;
        // #57266 - когда имя фьючерса (и каждого страйка) может присылать сервер
        this.FutureAliasName = null;
        this.useAliasName = false;
        this.Description = null;
        this.AdditionalFields = null;
        this.TradeSessionStatusId = null;
        this.ExchangeSessionName = null;
        // #67137 - используется в NonFixedInstumentStrikesResponseMessage,
        // нам здесь присылают алиас андерлаера для страйка
        this.Underlier = null;
        this.InstrumentTradableID = null;
        this.ISIN = '';
        this.LogoAddress = null;
    }
    getStrikePriceSettings(strikeVersion, strikePrice) {
        if (!isValidArray(this.StrikePricesList)) {
            return null;
        }
        const strikePriceSettings = this.StrikePricesList.find((sps) => sps.StrikeVersion === strikeVersion && sps.StrikePrice === strikePrice);
        if (isNullOrUndefined(strikePriceSettings)) {
            return null;
        }
        return strikePriceSettings;
    }
}
